import React from 'react';

function PrivacyPolicy() {
    return (
        <div>
            <section className="privacy-policy">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="block-text center" style={{marginTop: 100}}>
                                <h3 className="heading" style={{ color: "#119f24", marginBottom: 30 }}>
                                    Privacy Policy
                                </h3>
                            </div>
                        </div>

                        <div className="col-md-12" style={{marginBottom: 100}}>
                            <div className="privacy-content" style={{ color: "#ccc", fontSize: "16px", lineHeight: "1.8", textAlign: "left" }}>
                                
                                <h5 style={{marginTop: 20}}>1. Introduction</h5>
                                <p>
                                    Welcome to <strong>OSCAR Token</strong> (“OSCAR,” “we,” “our,” or “us”). This Privacy Policy outlines how we collect, use, and safeguard your data when you interact with the 
                                    OSCAR ecosystem, including our website, smart contracts, and other services.
                                </p>
                                <p>
                                    By using **OSCAR Token** on the **Moonshot launchpad on the Base Network**, you agree to this Privacy Policy. If you do not accept these terms, please discontinue use immediately.
                                </p>

                                <h5 style={{marginTop: 20}}>2. Information We Collect</h5>
                                <p>We do not require users to create accounts or submit personal data. However, the following data may be collected:</p>

                                <h5 style={{marginTop: 20}}>A. Blockchain and Wallet Data</h5>
                                <ul>
                                    <li><strong>Wallet Address:</strong> Your public address when interacting with OSCAR Token.</li>
                                    <li><strong>Transaction Data:</strong> All blockchain transactions related to staking, claims, and trading.</li>
                                    <li><strong>Smart Contract Interactions:</strong> Data from staking, claiming rewards, and other platform activities.</li>
                                </ul>
                                <p><em>Note:</em> All blockchain data is <strong>public, immutable, and accessible</strong> via blockchain explorers.</p>

                                <h5 style={{marginTop: 20}}>B. Website and Analytics Data</h5>
                                <ul>
                                    <li>IP address (temporarily logged for security).</li>
                                    <li>Browser type, device information, and referral sources.</li>
                                    <li>Pages viewed, session duration, and interaction logs.</li>
                                    <li>Crash reports and error logs.</li>
                                </ul>

                                <h5 style={{marginTop: 20}}>C. Communications and Customer Support</h5>
                                <p>If you contact us via email or social media, we may retain records of our communication to improve our services.</p>

                                <h5 style={{marginTop: 20}}>3. How We Use Your Information</h5>
                                <p>We use collected data for:</p>
                                <ul>
                                    <li>Optimizing platform functionality.</li>
                                    <li>Enhancing security and fraud detection.</li>
                                    <li>Improving website performance.</li>
                                    <li>Providing customer support.</li>
                                    <li>Ensuring compliance with legal regulations.</li>
                                </ul>
                                <p>We <strong>never sell or share your data</strong> with third parties for commercial purposes.</p>

                                <h5 style={{marginTop: 20}}>4. Data Storage and Security</h5>
                                <p>OSCAR Token is a **decentralized** project, meaning we do not store personal data.</p>
                                <ul>
                                    <li>All blockchain transactions are <strong>public and immutable</strong>.</li>
                                    <li>We implement **encryption**, **DDoS protection**, and **regular security audits**.</li>
                                    <li><strong>Users are responsible for their wallet security.</strong> We cannot recover lost private keys.</li>
                                </ul>

                                <h5 style={{marginTop: 20}}>5. How We Share Your Information</h5>
                                <ul>
                                    <li>Blockchain transactions are **publicly visible**.</li>
                                    <li>We may disclose data to **comply with legal obligations**.</li>
                                    <li>Third-party services (e.g., **DexScreener, MetaMask, DEXs**) have their own privacy policies.</li>
                                </ul>

                                <h5 style={{marginTop: 20}}>6. Your Rights & Control Over Data</h5>
                                <p>As a decentralized platform, users maintain full control of their data.</p>
                                <ul>
                                    <li>**Disconnect your wallet** anytime.</li>
                                    <li>**Clear cookies** and adjust browser privacy settings.</li>
                                    <li>**Verify transactions** directly on the blockchain.</li>
                                </ul>

                                <h5 style={{marginTop: 20}}>7. Cookies and Tracking</h5>
                                <p>We use cookies to enhance user experience, analyze traffic, and prevent security threats.</p>
                                <p>You can manage or disable cookies through your browser settings.</p>

                                <h5 style={{marginTop: 20}}>8. Third-Party Services & External Links</h5>
                                <p>OSCAR Token integrates with third-party services such as:</p>
                                <ul>
                                    <li><strong>DexScreener:</strong> for price tracking.</li>
                                    <li><strong>Wallet Providers:</strong> MetaMask, Phantom, and others.</li>
                                    <li><strong>Decentralized Exchanges (DEXs):</strong> for token swaps.</li>
                                </ul>
                                <p>We are <strong>not responsible</strong> for how these services handle your data.</p>

                                <h5 style={{marginTop: 20}}>9. Compliance with Regulations</h5>
                                <p>While OSCAR Token is decentralized, we adhere to applicable regulations, including:</p>
                                <ul>
                                    <li><strong>General Data Protection Regulation (GDPR)</strong></li>
                                    <li><strong>California Consumer Privacy Act (CCPA)</strong></li>
                                    <li><strong>U.S. Financial Regulations</strong></li>
                                </ul>
                                <p><em>Users are responsible for ensuring compliance with local laws regarding crypto use.</em></p>

                                <h5 style={{marginTop: 20}}>10. Updates to this Privacy Policy</h5>
                                <p>We may update this Privacy Policy periodically. Changes will be reflected with a <strong>“Last Updated” date</strong> at the top.</p>
                                <p>Continued use of **OSCAR Token** after updates signifies acceptance of the revised policy.</p>

                                <h5 style={{marginTop: 20}}>11. Contact Us</h5>
                                <p>For privacy-related inquiries, reach out to us through:</p>
                                <ul>
                                    <li><strong>Official Website: </strong><a href={"https://www.oscar.meme"} target='_blank'>https://www.oscar.meme</a></li>
                                    <li><strong>Community Support: </strong><a href={"https://discord.com/invite/5TEYunU7zg"} target='_blank'>Discord</a></li>  
                                </ul>

                                <hr style={{ borderTop: "1px solid #444", margin: "20px 0" }} />

                                <p><strong>Final Notes:</strong></p>
                                <ul>
                                    <li><strong>No KYC Required:</strong> We do not collect personal identification.</li>
                                    <li><strong>Non-Custodial:</strong> Users maintain full control of their funds.</li>
                                    <li><strong>Transparency First:</strong> All transactions are verifiable on the Base blockchain.</li>
                                </ul>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default PrivacyPolicy;
